export default {"src":"/_next/static/media/ru.8aa46a6f.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};